(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["biotiquest-experts"] && !Shopify.designMode) return;
  try {
    
  function waitForSwiper(trigger) {
    var interval = setInterval(function () {
      if (typeof Swiper != 'undefined') {
        clearInterval(interval);
        trigger();
      }
    }, 50);
    setTimeout(function () {
      clearInterval(interval);
    }, 15000);
  }

  function reviewSlider() {
    var swiper = new Swiper('.swiper-experts-slider', {
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next-experts',
        prevEl: '.swiper-button-prev-experts',
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
        0: {
          slidesPerView: 1,
          centeredSlides: true,
          spaceBetween: 20,
        },
      },
    });
  }

  function bindExpertCardMobileToggle() {
    var sections = document.querySelectorAll('.experts-section');
    if (!sections.length) return;

    sections.forEach(function (sectionEl) {
      if (sectionEl.dataset.expertToggleBound === '1') return;
      sectionEl.dataset.expertToggleBound = '1';

      sectionEl.addEventListener('click', function (e) {
        if (!window.matchMedia('(max-width: 767px)').matches) return;

        var toggleBtn = e.target.closest('.expert-toggle-btn-lp');
        if (!toggleBtn) return;

        e.preventDefault();
        e.stopPropagation();

        var card = toggleBtn.closest('.expert-card');
        if (!card) return;
        var isOpen = card.classList.contains('is-open');

        sectionEl.querySelectorAll('.expert-card.is-open').forEach(function (openCard) {
          if (openCard !== card) {
            openCard.classList.remove('is-open');
            var openBtn = openCard.querySelector('.expert-toggle-btn-lp');
            if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
          }
        });

        card.classList.toggle('is-open', !isOpen);
        var btn = card.querySelector('.expert-toggle-btn-lp');
        if (btn) btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  waitForSwiper(function () {
    reviewSlider();
    bindExpertCardMobileToggle();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-difference"] && !Shopify.designMode) return;
  try {
    
        let tabs = document.querySelectorAll(".tabs h3");
  let tabContents = document.querySelectorAll(".tab-content .difference_tab_content");
  tabs.forEach((tab, index) => {
    tab.addEventListener(w3elem, () => {
      tabContents.forEach((content) => {
        content.classList.remove("active");
      });
      tabs.forEach((tab) => {
        tab.classList.remove("active");
      });
      tabContents[index].classList.add("active");
      tabs[index].classList.add("active");
    },{passive:true});
  });

  } catch(e) { console.error(e); }
})();
})();
